<template>
    <div class="home">
    	<div class="container">
    		<div class="left">
	    		<div class="back ca" @click="handeRe()"></div>
	    		<div :class="[active=='canbusview'?'canbus active ca':'canbus ca']" @click="handleChange('canbusview')"><p v-html="langS[langv].t1"></p></div>
	    		<div :class="[active=='carview'?'car active ca':'car ca']" v-if="!isno" @click="handleChange('carview')"><p v-html="langS[langv].t2"></p></div>
	    		<div :class="[active=='appview'?'app active ca':'app ca']" v-if="!isno" @click="handleChange('appview')"><p v-html="langS[langv].t3">></p></div>
	    	</div>
	    	<div class="right">
	    		<div class="content canbusview" v-show="active=='canbusview'">
	    			<p class="title"  @click="Quick">{{data['canbusname'+lang]}}</p>
		    		<p class="tip"  @click="Quick">{{data['texttip'+lang]}}: <span class="time">{{data.time}}</span></p>
		    		<div class="desc" v-if="data['message'+lang]"  v-html="data['message'+lang].replace(/\r?\n/g, '<br />')">
					</div>


					<div class="downs">
						<Down :data="item" :name="item.name"  v-for="item,index in data.lists" :key="index"/>
						<!-- <a class="item" :href="data.url+item.url" v-for="item,index in data.lists" :key="index">
							{{item.name}} 
						</a> -->
					</div>
	    		</div>

	    		<div class="content carview" v-show="active=='carview'">
	    			<p class="title" v-html="langS[langv].t4">></p>
	    			<div class="box">
	    				<div class="boxv">
	    					<img src="@/assets/box/1.png">
	    					<p>Raise(RZC)</p>
	    				</div>
	    				<div class="boxv">
	    					<img src="@/assets/box/2.png">
	    					<p>Hiworld(HW)</p>
	    				</div>
	    				<div class="boxv">
	    					<img src="@/assets/box/3.png">
	    					<p>Xinbas(XBS)</p>
	    				</div>
	    				<div class="boxv">
	    					<img src="@/assets/box/4.png">
	    					<p>Binary(BNR)</p>
	    				</div>
	    				<div class="boxv">
	    					<img src="@/assets/box/5.png">
	    					<p>Simple Soft(XP)</p>
	    				</div>
	    			</div>
	    			<p class="title" v-html="langS[langv].t5">></p>
		    		<div class="carlist">
		    			<template v-for="item,index in car">
		    				<div :class="[activeindex==index?'item active':'item']"  @click="handeItem(item,index,$event)" :data-index=" Math.floor((index) / 7 )" :data-in="index"  :data-name="item.name" >
			    				<div class="bg" v-show="activeindex!=index" :style="{backgroundImage:'url(' + item.img + ')',}"></div>
			    				<div class="bg" v-show="activeindex==index" :style="{backgroundImage:'url(' + item.img1 + ')',}"></div>
			    			</div>
			    			<div class="inlist" v-if="(index) % 7==6 " :data-index=" Math.floor(index / 7 )" v-show="activeindex>=0 && activeShow==Math.floor((index) / 7 )" >
		    					<div class="in"  v-for="ci,cin in activeCar.list" :key="cin" @click="handeItemOpen(ci,cin)">
			    					{{ci.name}}
			    				</div>
				    		</div>
				    		<div class="inlist" v-if="car.length%7!=0 && index == (car.length-1)" :data-index=" Math.floor(index / 7 )" v-show="activeindex>=0 &&  activeShow==Math.floor(index / 7 )" >
		    					<div class="in"  v-for="ci,cin in activeCar.list" :key="cin" @click="handeItemOpen(ci,cin)">
			    					{{ci.name}}
			    				</div>
				    		</div>
		    			</template>
			    	</div>
	    		</div>

	    		<div class="content appview" v-show="active=='appview'" v-if="!isno">
	    			<div class="list-apps">
	    				<div class="item flex" v-for="item,index in apks" :key="index">
	    					<div class="img bg"  :style="{backgroundImage:'url(' + item.img + ')',}">
	    						
	    					</div>
	    					<div class="info">
	    						<div class="title">{{item.name}}</div>
	    						<div class="desc" v-if="item['desc'+lang]" v-html="item['desc'+lang].replace(/\r?\n/g, '<br />')"></div>
	    					</div>
	    					<div class="size">{{item.size}}MB</div>
	    					<Down :data="item"/>
	    				</div>
	    			</div>
	    		</div>

	    		<div class="mask" v-if="maskShow" @click="handleClose()">
	    			<div class="block">
	    				<div class="close" @click="handleClose()"></div>
	    				<div class="ctt">
	    					<img :src="activeImg">
	    				</div>
	    			</div>
	    		</div>

	    		<div class="mask" v-if="ivShow">
	    			<div class="block">
	    				<div class="close" @click="handleClose()"></div>
	    				<div class="ctt vi">
	    					<div class="">
	    						<div class="name"></div>
	    						<div class="it flex">
		    						<div class="" @click="ivajax(v)" v-for="v,i in data.types">{{v}}</div>
	    						</div>
	    						<div class="">{{jhtxt}}</div>
	    					</div>
	    				</div>
	    			</div>
	    		</div>

	    	</div>
    	</div>
    </div>
</template>
<script>

// import car from './car.json'
import Down from '@/components/down.vue'

export default {
    name: 'Home',
    components: {Down},
    data(){
    	return {
    		active:'canbusview',
    		ivShow:false,
    		lang:'',
    		langv:'ru',
    		car:[],
    		activeCar:[],
    		apks:[],
    		activeindex:-1,
    		activeImg:'',
    		activeShow:-1,
    		maskShow:false,
    		data:{
    			message:''
    		},
    		isno:false,
    		jhtxt:'',
    		quickNUm:0,
    		yfdata:{
    			UUID:''
    		},
    		langS:{
    			zh:{
    				t1:'Canbus <br> Update',
    				t2:'Model Selection',
    				t3:'Apps',
    				t4:'Canbus Box',
    				t5:'Выбор модели',
    				t6:'下载'
    			},
    			ru:{
    				t1:'Canbus <br> Update',
    				t2:'Model <br> Selection',
    				t3:'Apps',
    				t4:'Canbus Box',
    				t5:'Выбор модели',
    				t6:'Скачать'
    			},
    			En:{
    				t1:'Canbus <br> Update',
    				t2:'Model <br> Selection',
    				t3:'Apps',
    				t4:'Canbus Box',
    				t5:'Выбор модели',
    				t6:'Download'
    			},
    			Vi:{
    				t1:'Cập nhật <br> CANBUS',
    				t2:'Lựa chọn <br> mẫu xe',
    				t3:'Ứng dụng',
    				t4:'Hộp CANBUS',
    				t5:'Lựa chọn mẫu xe',
    				t6:'Tải về'
    			},
    			Ko:{
    				t1:'Canbus <br> 업데이트',
    				t2:'모델선택',
    				t3:'앱',
    				t4:'Canbus Box',
    				t5:'모델 선택',
    				t6:'다운로드',
    			},
    		}
    	}
    },
    created(){
    	// console.log(data)
    	// this.data = data
    	var lang =(navigator.language || navigator.browserLanguage).toLowerCase();
    	if(lang.indexOf('ru')>=0){
    		this.lang=''
    		this.langv='ru'
    	}else if(lang.indexOf('vi')>=0){
    		this.langv='Vi'
    		this.lang='Vi'
    	}else if(lang.indexOf('ko')>=0){
    		this.langv='Ko'
    		this.lang='Ko'
    	}else{
    		this.langv='En'
    		this.lang = 'En'
    	}
    	console.log(this.lang)
    	if(lang.indexOf('zh')>=0){
    		this.isno = true
    		this.langv='zh'
    		this.lang = 'zh'
    	}else{
    		this.active = 'appview'
    	}
    	this.data = window.apk
    	this.car = window.car
    	this.apks = window.apks
    	this.getData()
    },
    methods:{
    	getData(){
    		var lang =(navigator.language || navigator.browserLanguage).toLowerCase();

    		if(typeof teyes!='undefined'){
    			if(typeof teyes.UUID!='undefined'){
    				this.yfdata.UUID = teyes.UUID('')
    			}
    		}
    		ajax.post('https://custom.teyes.ru/api/Yfcanbus/apk',"lang="+lang+"&imei="+this.yfdata.UUID,(res)=>{
    			var res = JSON.parse(res)
    			
    			for (var i = 0; i < res.data.lists.length; i++) {
    				res.data.lists[i].url  =  res.data.lists[i].url
    			}

    			this.data = res.data 


    			ajax.post('https://custom.teyes.ru/api/Yfcanbus/car',"lang="+lang,(res)=>{
	    			var res = JSON.parse(res)
	    			// console.log(res)
	    			this.car = res.data 
	    		})

	    		ajax.post('https://custom.teyes.ru/api/Yfcanbus/apks',"lang="+lang+"&imei="+this.yfdata.UUID,(res)=>{
	    			var res = JSON.parse(res)
	    			// console.log(res)
	    			this.apks = res.data 
	    		})

	    		var that = this 
	    		if(typeof teyes!='undefined'){
    				if(typeof teyes.UUID!='undefined'){
    					var data = 'key=daefa573-2525-4f4f-929b-65c68c00c30b&imei='+teyes.UUID('')+'&wifi='+teyes.Wifi('')

			    		ajax.post('https://custom.teyes.ru/api/Yfonline/wifi',data,(res)=>{
			    			var res = JSON.parse(res)
			    			if(res.code==1){
			    				that.ivShow = true
			    			}
			    		})
    					
    				}
    			}
    		})
    		

    	},
    	Quick(){
    		++this.quickNUm 
    		if(this.quickNUm==2){
    			this.ivShow = true
    			this.quickNUm =0
    		}
    		
    	},
    	ivajax(type){
    		var lang =(navigator.language || navigator.browserLanguage).toLowerCase();
    		var that = this
    		if(typeof teyes!='undefined'){
    			if(typeof teyes.UUID!='undefined'){
    				if(typeof teyes.Wifi!='undefined'){
    					var data = 'key=daefa573-2525-4f4f-929b-65c68c00c30b&imei='+teyes.UUID('')+'&type='+type+'&lang='+lang+'&wifi='+teyes.Wifi('')

			    		ajax.post('https://custom.teyes.ru/api/Yfonline/getNotice',data,(res)=>{
			    			var res = JSON.parse(res)
			    			that.jhtxt ='激活成功'
			    		})
    				}
    			}
    		}
    		
    	},
    	
    	handeRe(){
    		window.location.reload()
    	},
    	handleChange(type){
    		this.active = type
    	},
    	handeItem(item,index,e){
    		console.log(e.currentTarget.dataset.index)
    		this.activeCar = item
    		if(index == this.activeindex){
    			this.activeindex = -2
    		}else{
    			this.activeindex = index
    			this.activeShow = e.currentTarget.dataset.index
    		}
    		
    	},
    	handeItemOpen(item,index){
    		this.maskShow = true
    		// this.activeImg = 'https://cdn.teyes.cn/canbus/xy/'+this.activeCar['name']+'/'+item.title+'.png'
    		this.activeImg =  item.img
    	},
    	handleClose(){
    		this.maskShow = false
    		this.ivShow = false
    	},
    	handeBack(){
    		this.activeindex=-1
    		this.activeShow=-1
    	}
    }
}
</script>

<style lang="less">
	.vi{
		background-color:#fff;
		padding:10px;
		font-size: 16px;
		border-radius:10px;
		div{
			color: #000;
			// text-align: left;
			font-size: 24px;
		}
		.flex{
			display: flex;
			align-items:center;
		}
		.it{
			margin: 20px 0; 
			flex:1;
			>div{
				background-color:#0f75e7;
				margin: 10px;
				width: 162px;
				border-radius:8px;
				font-size: 24px;
				padding:30px 0;
				text-align: center;
				color: #fff;
			}
		}
	}
	.home{
		background-color: #22222d;
		height: 100vh;
		width: 100vw;
		overflow: auto;
		.container{
			padding: 20px;
			display: flex;
			flex-wrap: wrap;
		}
		a{
			text-decoration:  none;
		}
		.left{
			width: 14vw;
		}
		.ca{
			cursor: pointer;
		}
		
		.mask{
			position:absolute;
			top: 0;
			background-color:#dedede5c;
			left: 0;
			right: 0;
			bottom:0;
			display: flex;
			align-items:center;
			justify-content: center;
			z-index: 10;
			text-align: center;
			img{
				width: 100%;
			}
			.block{
				width: 80%;
				position: relative;
			}
			.ctt{
				width: 100%;
				max-height: 80vh;
				overflow: auto;
			}
			.close{
				position:absolute;
				top: -25px;
				right: -25px;
				width: 50px;
				height: 50px;
				background-size:cover;
				cursor: pointer;
				background-image:url(../assets/close.png);
			}
		}
		.box{
			display: flex;
			margin-top: 20px;
			justify-content: space-between;
				margin-right: 20px;
			.boxv{
				margin-right: 20px;
				margin-bottom: 20px;
				text-align: center;
			}
			img{
				width: 123px;
				margin-bottom: 10px;
			}
		}
		.back{
			background-image:url('../assets/re.png');
			background-size:cover;
			background-position:center;
			border-radius:10px;
			overflow: hidden;
			width: 100%;
			height: calc(11vw / 2);
			&:hover{
				background-image:url('../assets/re_p.png');
			}
		}
		.car{
			margin-top: 20px;
			background-image:url('../assets/car.png');
			background-size:cover;
			background-position:center -2vw;
			border-radius:10px;
			overflow: hidden;
			width: 100%;
			height: calc(9vw / 0.7);
			display: flex;
		    align-items: flex-end;
		    justify-content: center;
		    text-align: center;
		    p{
		    	margin-bottom:18px;
		    	color: #5d6572;
		    	font-size: 20px;
		    }
			&:hover,&.active{
				background-image:url('../assets/car_p.png');
				p{
					color: #fff
				}
			}
		}
		.canbus{
			margin-top: 20px;
			background-image:url('../assets/canbus.png');
			background-size:cover;
			background-position:center -2vw;
			border-radius:10px;
			overflow: hidden;
			width: 100%;
			height: calc(9vw / 0.7);
			display: flex;
		    align-items: flex-end;
		    justify-content: center;
		    p{
		    	margin-bottom:18px;
		    	font-size: 20px;
		    	color: #5d6572;
		    }
			&:hover,&.active{
				background-image:url('../assets/canbus_p.png');
				p{
					color: #fff
				}
			}
		}
		.app{
			margin-top: 20px;
			border-radius:10px;
			background-image:url('../assets/app.png');
			background-size:cover;
			width: 100%;
			height: calc(9vw / 0.7);
			display: flex;
		    align-items: flex-end;
		    justify-content: center;
		    p{
		    	margin-bottom:20px;
		    	font-size: 20px;
		    	color: #5d6572;
		    }
			&:hover,&.active{
				background-image:url('../assets/app_p.png');
				p{
					color: #fff
				}
			}
		}
		.right{
			flex:1;
			// width: calc(100vw - 220px);

		}
		.content{
			flex:1;
			margin: 0 20px;
			height: calc(100vh - 40px);
			overflow: auto;
			overflow-x: hidden;
			.list-apps{

				.item{
					display: flex;
					margin-bottom: 20px;
					padding-bottom:20px;
					border-bottom: 1px solid #32313e;
					align-items:center;
					&:last-child{
						border-bottom:none;
					}
					.img{
						width: 78px;
						height: 78px;
						background-size:cover;
						border-radius:10px;
						overflow: hidden;
						margin-right: 20px;
					}
					.info{
						flex: 1;
						margin-right: 20px;
						.title{
							font-size: 20px;
							font-weight: bold;
							margin-bottom: 10px;
						}
						.desc{
							font-size: 14px;
							color: rgba(255,255,255,0.5);

						}
					}
					.size{
						font-size: 20px;
						margin-right: 20px;
						font-weight: bold;
					}
					
				}
			}
			&.canbusview{
				.title{
					text-align: center;
					font-size: 26px;
					margin-top: 20px;
				}
				.tip{
					text-align: center;
					margin-bottom: 40px;
					padding-bottom:20px;
					border-bottom: 1px solid #32313e;
					.time{
						color: #0f75e7;
					}
				}
				.desc{
					margin: 40px 40px;
					p{
						margin-bottom: 20px;
						font-size: 20px;
					}
				}
				.downs{
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;
					position: absolute;
					bottom:50px;
					left: 20vw;
					right: 50px;
					.down{
						width: 140px;
					}
				}
			}
			&.carview{
				.title{
					font-size: 26px;
				}
				.carlist{
					display: flex;
					flex-wrap: wrap;
					margin: 20px 0; 
					// width: calc(100vw - 254px);

					>div{
						margin-right: 20px;
						margin-bottom: 20px;
						// width: 100px;
						// height: 100px;
						&:nth-child(7),
						&:nth-child(15){
							margin-right: 0
						}
					}
					.item{
						cursor: pointer;
						width: 12%;
						position: relative;
						.bg{
							max-width: 123px;
							width: 100%;
							height: 123px;
							background-repeat:no-repeat;
							background-position:center;
							background-size:100% auto;
						}
						
					}
					.inlist{
						// width: calc(100vw - 288px);
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						margin: 0px 0 20px 0;
						// display: none;
						.in{
							width: 31%;
							padding: 10px 0;
							text-align: center;
							border-radius:8px;
							margin-right: 10px;
							margin-bottom: 10px; 
							border:2px solid #fff;
							&:hover,&.active{
								border-color:#0f74e7;
							}
						}
					}
				}
			}


		}
	}
	@media screen and (max-width: 1025px) {
			.home .canbus p{
				font-size: 14px;
			}
			.home .car p{
				font-size: 14px;
			}
			.home .content.carview .carlist .item{
				width: 11%;
			}
	}
</style>